export enum UserGroup {
    ADMIN = 'admin',
    DEV_INTERNAL_ENGINEERS = 'dev-internal_engineers',
    PROD_INTERNAL_ENGINEERS = 'prod-internal_engineers',
    INTERNAL_PRODUCT_MANAGER = 'internal_product_manager',
    DEV_INTERNAL_QA = 'dev-internal_qa',
    PROD_INTERNAL_QA = 'prod-internal_qa',
}
